<template>
  <div v-if="data" class="d-flex align-center" style="position: relative">
    <!-- 비동기 업로드 중 -->
    <div v-if="data?.is_processing" class="d-flex align-center justify-center" :style="{width: iconWidth, height: iconHeight}">
      <!-- <img src="/assets/loading.svg" style="width: 20px; height: 20px"> -->
      <v-progress-circular 
        :size="20" :width="2" color="#D8DAE9" indeterminate
      ></v-progress-circular>
    </div>
    <!-- file/category 별 분류 -->
    <img v-else
      :src="iconSrc"
      :style="{width: iconWidth, height: iconHeight}"
    >

    <!-- showErrorDot (표 검출 메뉴에서 표시) -->
    <div v-if="showErrorDot" class="d-flex align-center justify-center"
      style="position: absolute; right: -5px; bottom: -5px; width: 18px; height: 18px; border-radius: 999px; background-color: #ffffff"
    >
      <v-icon style="font-size: 14px; color: #FF0000">
        mdi-alert-circle
      </v-icon>
    </div>
    <!-- 즐겨찾기 표시 -->
    <img v-else-if="showFavorite && favorite"
      src="/assets/favorite-small.svg"
      style="position: absolute; right: 1px; bottom: 1px"
      :style="{width: `calc(${iconWidth}/2)`, height: `calc(${iconHeight}/2)`}"
    >
  </div>
</template>

<script>
import { getFileIconSrc } from "@/utils/fileMetadata"

export default {
  name: "DataIcon",

  props: {
    data: {
      type: Object,
      default: () => {}
    },
    iconWidth: {
      type: String,
      default: '26px'
    },
    iconHeight: {
      type: String,
      default: '26px'
    },
    showFavorite: {
      type: Boolean,
      default: true
    },
    favorite: {
      type: Number,
      default: 0
    },
    showErrorDot: {
      type: Boolean,
      default: false
    },
  },

  computed: {
    iconSrc() {
      return getFileIconSrc(this.data)
    },
  },
}
</script>

<style scoped>
</style>
